import React, { FC } from 'react'
import { UseFormMethods } from 'react-hook-form'
import ControlledCheckbox from 'transfix-form/components/ControlledCheckbox'
import ControlledSelect from 'transfix-form/components/ControlledSelect'
import ControlledTextInput from 'transfix-form/components/ControlledTextInput'
import { Card } from 'transfix-ui/components/Card'
import { Grid } from 'transfix-ui/core'
import { ICarrierApplicationEntityTypes } from 'types/graphqlTypes'
import { getErrorMessage } from '../schema'
import ValidatedCarrierNumberInput from './ValidatedCarrierNumberInput'

const ENTITY_TYPE_OPTIONS = [
  {
    label: 'Individual/sole proprietor or single member LLC',
    value: ICarrierApplicationEntityTypes.individual,
  },
  {
    label: 'C Corporation',
    value: ICarrierApplicationEntityTypes.ccorp,
  },
  {
    label: 'S Corporation',
    value: ICarrierApplicationEntityTypes.scorp,
  },
  {
    label: 'Partnership',
    value: ICarrierApplicationEntityTypes.partnership,
  },
  {
    label: 'Trust/Estate',
    value: ICarrierApplicationEntityTypes.trust,
  },
  {
    label: 'Limited Liability Company',
    value: ICarrierApplicationEntityTypes.llc,
  },
]

export interface ICompanyInfoFormSectionProps
  extends Pick<UseFormMethods, 'control' | 'errors' | 'trigger' | 'setError' | 'clearErrors'> {}

const CompanyInfoFormSection: FC<ICompanyInfoFormSectionProps> = ({
  clearErrors,
  control,
  errors,
  setError,
  trigger,
}) => {
  return (
    <Card title='Company Information'>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={12}>
          <ControlledTextInput
            control={control}
            name='name'
            TextInputProps={{
              label: 'Legal Name',
              dataTest: 'legal-name-field',
              error: Boolean(getErrorMessage(errors, 'name')),
              validationMessage: getErrorMessage(errors, 'name'),
              required: true,
            }}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <ControlledTextInput
            control={control}
            name='dbaName'
            TextInputProps={{
              label: 'DBA',
              error: Boolean(getErrorMessage(errors, 'dbaName')),
              validationMessage: getErrorMessage(errors, 'dbaName'),
            }}
          />
        </Grid>
        <Grid item xs={12} lg={4} data-test='mc-number-field'>
          <ValidatedCarrierNumberInput
            control={control}
            name='mcNumber'
            errors={errors}
            trigger={trigger}
            setError={setError}
            clearErrors={clearErrors}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <ControlledTextInput
            control={control}
            name='ein'
            TextInputProps={{
              label: 'EIN',
              error: Boolean(getErrorMessage(errors, 'ein')),
              validationMessage: getErrorMessage(errors, 'ein'),
              type: 'number',
            }}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <ControlledSelect
            control={control}
            name='entityType'
            SelectProps={{
              label: 'Entity Type',
              options: ENTITY_TYPE_OPTIONS,
              error: Boolean(getErrorMessage(errors, 'entityType')),
              validationMessage: getErrorMessage(errors, 'entityType'),
            }}
          />
        </Grid>
        <Grid item xs={12} lg={4} data-test='dot-number-field'>
          <ValidatedCarrierNumberInput
            control={control}
            name='dotNumber'
            errors={errors}
            trigger={trigger}
            setError={setError}
            clearErrors={clearErrors}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <ControlledCheckbox
            control={control}
            name='isDisadvantagedBusinessEntity'
            CheckboxProps={{
              label: 'D/M/WBE Compliant',
            }}
          />
        </Grid>
      </Grid>
    </Card>
  )
}

export default CompanyInfoFormSection
